import * as React from "react";
import { Container, Dropdown, Accordion, Card, Button,Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { ReportsService } from "../../Common/Services/ReportsService";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Utils } from "../../Common/Utilis";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import Customerorderslideout from '../../Modules/Customerorderslideout';
import Receivableslideout from '../../Modules/Accounts/Receivableslideout';
import  Vendororderslideout  from "../../Modules/Vendororderslideout";
import  InvoiceEntryslideout  from "../../Modules/Purchasing/InvoiceEntryslideout";
import  DepositSlideout  from "../../Modules/Transaction/DepositSlideout";
import  InvoiceSlideout  from "../../Modules/Transaction/InvoiceSlideout";
import  JournalSlideout  from "../../Modules/Transaction/JournalSlideout";
import  WithdrawalSlideout  from "../../Modules/Transaction/WithdrawalSlideout";
import _ from "lodash";
const { SearchBar } = Search;

import createDOMPurify from "dompurify";
 
import moment from "moment";

  
export class Drilldown extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
          showSlideout:false,
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          orderid:0,
          selectedcolumn: "All",
          selectOptions: [{
            id: 'All', name: 'All'
          },
          { id: 'Doc ID.', name: 'Doc ID.' },
          { id: 'Type', name: 'Type' },
          { id: 'Prepared By', name: 'Prepared By' },
          { id: 'Approved By', name: 'Approved By' },
          { id: 'Date', name: 'Date' },
          ],
        isdocid : true,
        istype : true,
        ispreparedby : true,
        isapprovedby : true,
        isdate : true
        };
        
     
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let isdocid = id == "Doc ID." ? true : false;
        let istype = id == "Type" ? true : false;
        let ispreparedby = id == "Prepared By" ? true : false;
        let isapprovedby = id == "Approved By" ? true : false;
        let isdate = id == "Date" ? true : false;

    
        if (id == "All") {
          isdocid = true;
          istype = true;
          ispreparedby = true;
          isapprovedby = true;
          isdate = true;
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isdocid: isdocid, istype: istype,
          ispreparedby: ispreparedby, isapprovedby: isapprovedby,isdate:isdate
        },
          () => {
            this.setState({ searcResult: searcResult1 });
          }
    
        );
    
      };
    
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getDrill(requestlist);
      }

      getparam(para:string) : any {
        debugger;
let paravalue=new URLSearchParams(window.location.search).get(para);
return window.atob(paravalue==null ? "" : paravalue);

       }

 
      getDrill = (requestlist: any) => {
        debugger;
      const queryString = window.location.search;
               const urlParams = new URLSearchParams(queryString);


 //const vid = urlParams.get('vid');
// const date :any= urlParams.get('Date');

         const vid =this.getparam("vid");
        // // urlParams.get('vid'); 
         let Date = this.getparam("Date");
let DateT=this.getparam("DateT");
const coa=this.getparam("COA");
const reportid=this.getparam("reportid");

        //urlParams.get('Date');
      //  let decodedDate :any= decodeURIComponent(date);
      //   let finalDate = decodedDate.replace(/'/g, '');

        requestlist.locationId =0;
        requestlist.date=Date;
        requestlist.isApproved=1;
        requestlist.vid=vid;
        requestlist.coa=coa;
        requestlist.DateT=DateT;
        requestlist.reportid=reportid;
        ReportsService.GetDrill(requestlist)
    .then(async (result: any[] | null) => {
        
      if (result != null) {
        
        this.setState({ searcResult: result }, () => {
           
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });
  };

  showslideout = () => {
    this.setState({ showSlideout: true });
  };

 

  handleRowClick = (row: any, rowIndex: number, event: any) => {
    console.log("Row clicked:", row, "at index:", rowIndex);

   
   if(row.type=='deposit')
    {
     this.setState({
      showDepositSlideout: true, orderid: row.id, footershow:false,  shipmentId: 0, isSpinner: false,
     });
   }

   if(row.type=='invoice')
    {
     this.setState({
      showInvoiceSlideout: true, orderid: row.id, footershow:false,  shipmentId: 0, isSpinner: false,
     });
   }

   if(row.type=='withdrawal')
    {
     this.setState({
      showWithdrawalSlideout: true, orderid: row.id, footershow:false,  shipmentId: 0, isSpinner: false,
     });
   }


   if(row.type=='journal')
    {
     this.setState({
      showJournalSlideout: true, orderid: row.id, footershow:false,  shipmentId: 0, isSpinner: false,
     });
   }


   if(row.type=='customerinvoice')
    {
     this.setState({
       showReceivableslideout: true, 
       orderid: 0,
       invoiceId: row.id,    
       isSpinner: false,
      });
 
    }

   if(row.type=='vendorinvoice')
    {
     this.setState({
       showVendorInvoiceslideout: true, 
       orderid: 0,
       invoiceId: row.id,    
       isSpinner: false,
      });
 
    }
    
    
   if(row.type=='customerorder')
    {
     this.setState({
       showSlideout: true, orderid: row.id,   shipmentId: 0, isSpinner: false,
     });
   }
 

    if( row.type == "vendororder")
      {
       this.setState({
         showVendorslideout: true, 
         isSpinner: false,
         vendororderid: row.id,
         vendorordertype: row.OrderType,
         orderid: row.id
        });
      }
    
  };


  closeSlideOut = () => {
    this.setState({ 
      showVendorslideout:false, 
      showDepositSlideout:false,
      showReceivableslideout:false,
      showInvoiceSlideout:false,
      showJournalSlideout:false,
      showWithdrawalSlideout:false,
      showVendorInvoiceslideout:false,
      showSlideout: false,
      isSpinner: false, 
      footershow:false,
      orderid:0 });
      this.getDrill({});

  };



    render() { 
      const {
        showSlideout,
        showReceivableslideout,
        showVendorslideout,
        showVendorInvoiceslideout,
        showDepositSlideout,
        showInvoiceSlideout,
        showJournalSlideout,
        showWithdrawalSlideout,searcResult,
      } = this.state;

      const totalAmount = searcResult.reduce((sum, item) => sum + (item.amount || 0), 0);

      const customTotal = (from, to, size) => (
        <span className="text-muted">
          Showing {from} to {to} of {size} entries
        </span>
      );

      const rowEvents = {
        onClick: (e: any, row: any, rowIndex: number) => this.handleRowClick(row, rowIndex, e),
      };

      
      const options = {
  
        showTotal: true,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [{
          text: '10', value: 10
        },
        {
          text: '25', value: 25
        },
        {
          text: '50', value: 50
        },
  
        {
          text: 'All', value: this.state.searcResult.length
        }] // A numeric array is also available. the purpose of above example is custom the text
      };
  
      const columns = [
        {
          dataField: 'vendorCode',
          text: 'Vendor Code',
          sort: true,
          searchable: this.state.isdocid,
        },
        {
          dataField: 'vendorName',
          text: 'Vendor Name',
          sort: true,
          searchable: this.state.istype,
        },
        {
          dataField: 'period',
          text: 'Period',
          sort: true,
          
        },
        {
            dataField: "date",
            text: "Date",
            classes:"expanding-bar",
            sort: true,
            searchable: this.state.date,
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <EllipsisWithTooltip placement="bottom">
                   { row.date=="0001-01-01T00:00:00" || row.date==undefined ? "" : moment(row.date).format("MM/DD/YYYY")}
                </EllipsisWithTooltip>
              );
            },
          },
        {
          dataField: 'invoiceNo',
          text: 'Invoice No.',
          sort: true,
        },
      
        {
            dataField: 'ckno',
            text: 'Check No.',
            searchable: this.state.ispreparedby,
            sort: true,
          },

           {
                  dataField: 'amount',
                  text: 'Amount',
                  headerClasses: 'text-start pe-4',
                  classes: 'text-start pe-4 divgreen',
                  sort: true,
                  searchable: this.state.ispreparedby,
                  formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                      <EllipsisWithTooltip placement="bottom">
                        {Utils.currencyFormat(row.amount)}
                      </EllipsisWithTooltip>
                    );
                  },
                },
          
        {
          dataField: 'lastAccountno',
          text: 'Account',
          searchable: this.state.isapprovedby,
          sort: true,
        },
        
       
      ];

        return (
            <>
<React.Fragment>
  
        
          <Container fluid className="body-sec">
           

<div className="page-heading d-flex justify-content-between align-items-center">
            <h4>ACCOUNT PAYABLES</h4>
            <h5 className="text-primary">Total Amount: {Utils.currencyFormat(totalAmount)}</h5>
          </div>
        
                  <ToolkitProvider
                    keyField="id"
                    data={this.state.searcResult}
                    columns={columns}

                    search
                  >
                    {
                      props => (
                        <div>

<section className="d-flex flex-wrap gap-3 pb-2">
                           
                          </section>
                          <section className="pb-3">
                            <div className="table-responsive1 divbottom"  >
                              <div className="ml-auto transactions-list">
                          <BootstrapTable
                            {...props.baseProps}
                            rowEvents={rowEvents}
                            pagination={paginationFactory(options)}
                            
                          />
                       </div>
                            </div>
                          </section>
                        </div>
                      )
                    }
                  </ToolkitProvider>

  {showDepositSlideout &&
    <DepositSlideout 
    transactionID={this.state.orderid}   
    closeSlideOut={this.closeSlideOut}/>
  }

   {showInvoiceSlideout &&
    <InvoiceSlideout transactionID={this.state.orderid} closeSlideOut={this.closeSlideOut}/>
    }

     {showWithdrawalSlideout &&
    <WithdrawalSlideout transactionID={this.state.orderid} closeSlideOut={this.closeSlideOut} />
    }
    
    {showJournalSlideout&&
    <JournalSlideout journalEntryID={this.state.orderid} closeSlideOut={this.closeSlideOut} />
    }
    


{(showSlideout &&
  <Customerorderslideout
    closeSlideOut={this.closeSlideOut}
    orderid={this.state.orderid}
  
  >


  </Customerorderslideout>
)}


{(showReceivableslideout &&
                <Receivableslideout
                  closeSlideOut={this.closeSlideOut}
                  orderid={this.state.orderid}
                  orderIds={this.state.orderIds}
                  products={this.state.products}
                  invoiceId={this.state.invoiceId}
                >


                </Receivableslideout>
              )}

          {(showVendorslideout && 
        <Vendororderslideout
        closeSlideOut={this.closeSlideOut}
        orderid={this.state.orderid}
        vendororderid={this.state.vendororderid}
        vendorordertype={this.state.vendorordertype}
        id={this.state.vendororderid}
        ></Vendororderslideout>
          )}

       
       
        {showVendorInvoiceslideout && 
        <InvoiceEntryslideout
        closeSlideOut={this.closeSlideOut}
        orderIds={[]}
        invoiceId={this.state.invoiceId}
        itemIds={[]}
        />
        }


   </Container>
       
      
      </React.Fragment>
            </>
        );
    }

}
